export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";